"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LastModifiedBy = function LastModifiedBy() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Shows the collaborator that a record was most recently modified by in any editable field or just in specific editable fields."));
};

var _default = LastModifiedBy;
exports["default"] = _default;